export default "__VITE_ASSET__c6fc6c20__"